import React from "react";
import { Link } from "react-router-dom";
import "./Implementation.css";

function Implementation() {
  return (
    <>
      {/* WRAPPER PRINCIPAL */}
      <div className="implementation-wrapper">

        {/* CARD */}
        <div className="implementation-card">
          <h2 className="implementation-title">Evaluation dashboard</h2>

          <div className="implementation-buttons">
            <Link to="/measuring-form_" className="action-button context">
              <span className="button-icon">🏢</span>
              New Acquisition Context
            </Link>

            <Link to="/compare-cases" className="action-button compare">
              <span className="button-icon">📊</span>
              Compare Case Progress
            </Link>
          </div>
        </div>
      </div>

      {/* FOOTER EN DEHORS DU WRAPPER, comme pdf-uploader */}
      <div className="icam-navigation">
        <Link to="/conception">
          <button className="footer-btn">Back to Conception</button>
        </Link>
      </div>
    </>
  );
}

export default Implementation;
